import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations, contactInfo } from '../data/mock';
import { Mail, Phone } from 'lucide-react';

const Footer = () => {
  const { language } = useLanguage();
  const t = translations[language];
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-stone-900 py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center">
          {/* Logo */}
          <div className="mb-6 md:mb-0">
            <span className="font-serif text-xl text-white tracking-wider">
              PAPUECAS 24
            </span>
          </div>

          {/* Contact Info */}
          <div className="flex flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-8 mb-6 md:mb-0">
            <a
              href={`tel:${contactInfo.phone}`}
              className="flex items-center text-white/60 hover:text-white transition-colors text-sm"
            >
              <Phone size={16} className="mr-2" />
              {contactInfo.phone}
            </a>
            <a
              href={`mailto:${contactInfo.email}`}
              className="flex items-center text-white/60 hover:text-white transition-colors text-sm"
            >
              <Mail size={16} className="mr-2" />
              {contactInfo.email}
            </a>
          </div>

          {/* Copyright */}
          <div className="text-white/40 text-sm">
            © {currentYear} Papuecas 24. {t.footer.rights}.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
